import { GridRef } from "@/components/wijmo-grid/grid/grid";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";

export interface GridCols {
	bindTo: string;
	heading: string;
	render?: Function;
}

@Component({
	components: {
		Grid
	}
})
export default class TextAnalysisGrid extends Vue {
	@Ref() readonly gridCompRef!: GridRef;
	@Prop() cols!: GridCols[];
	@Prop() dataSource!: [];
	@Prop() loading!: boolean;
	@Prop() title!: string;
}
